export default __webpack_public_path__ + "static/media/drag-icon.ddc56039.svg";